import { useQuery } from '@tanstack/react-query';
import { useActiveOrganization } from '@/hooks/useActiveOrganization';
import { queryKeys } from '@/lib/query-keys';
import { executeQuery } from '@/lib/execute-query';
import { Action } from '@/business/types/action.types';

interface ProfileUser {
  id: string;
  username: string;
  display_name: string;
  role: string;
  profile_image?: string;
  organization_id: string;
}

interface ProfilePreferences {
  theme?: string;
  mood?: string;
  sizing?: string;
  playful_theme?: string;
}

interface ProfileBoard {
  id: string;
  title: string;
  group_id?: string;
  tag?: string;
}

export interface ProfileData {
  user: ProfileUser;
  preferences?: ProfilePreferences;
  boards: ProfileBoard[];
}

export function useUserProfileQuery(userId: string | undefined) {
  const { activeOrganizationId } = useActiveOrganization();

  return useQuery({
    queryKey: queryKeys.userProfile.forUser(userId!, activeOrganizationId),
    queryFn: () =>
      executeQuery<{ user_id: string }, ProfileData>(Action.GET_USER_PROFILE, {
        user_id: userId!,
      }),
    staleTime: 1000 * 60 * 3,
    enabled: !!userId,
  });
}
